import { doSignoutTask } from '../user/doSignoutTask';

const userAuthFailed = async () => {
  doSignoutTask();
};

export { userAuthFailed };
